<template>
  <div>
    <div :name="getWarningName" class="warning">
      <div class="warning__icon">
        <i class="icon icon-warning"></i>
      </div>
      <div class="warning__text">
        <p v-html="warningText"></p>
      </div>
    </div>
    <tippy v-if="isHeaderWarning" :to="'page_header_warning'" :arrow="true" theme="wf-bp">
      <p>{{ $t("missions.warning") }}</p>
    </tippy>
  </div>
</template>

<script>
export default {
  name: "Warning",

  props: {
    warningText: {
      type: String,
      required: true,
    },
    isHeaderWarning: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getWarningName() {
      return this.isHeaderWarning ? "page_header_warning" : "";
    },
  },
};
</script>
